import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const ProfessionalNameStyled = styled.div`
  display: flex;
  align-items: center;

  > img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }

  > div:last-child {
    display: grid;
    gap: 2px;
    margin: 0 12px;

    > p {
      color: ${({ theme }) => theme.color.grey900};
      font-size: 14px;
      font-weight: 700;
      line-height: 22px;
    }
    > span {
      color: ${({ theme }) => theme.color.grey700};
      font-size: 14px;
      font-weight: 400;
      line-height: 19.6px;
      width: 300px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const AvatarStyled = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.color.blueDark100};
  border-radius: 50%;
  > svg {
    path {
      fill: ${({ theme }) => theme.color.grey900};
    }
  }
`;

export const TableStyled = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  overflow-x: auto;

  ::-webkit-scrollbar {
    border-radius: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 6px;
    background: ${({ theme }) => theme.color.grey50};
  }

  > table {
    width: 100%;
    overflow: scroll;
    thead {
      th {
        border-bottom: 1px solid ${({ theme }) => theme.color.grey200};
        background: ${({ theme }) => theme.color.grey50};
        padding: 16px 24px;
        text-align: left;
        color: ${({ theme }) => theme.color.grey600};
        font-family: Mulish;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        letter-spacing: 0.07px;
        border-bottom: 1px solid ${({ theme }) => theme.color.grey200};

        &:first-child {
          position: sticky;
          left: 0;
        }

        span {
          display: block;
          white-space: nowrap;
        }
      }

      .firstColumn {
        width: 300px;
      }
    }

    td {
      padding: 16px 24px;
      font-family: Mulish;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
      color: ${({ theme }) => theme.color.grey700};
      border-bottom: 1px solid ${({ theme }) => theme.color.grey200};

      &.firstColItem {
        position: sticky;
        left: 0;
        background: ${({ theme }) => theme.color.white};
        font-weight: 700;
        color: ${({ theme }) => theme.color.grey900};
      }
    }
  }
`;
